import Box from 'UIKit/Box/Box'
import Flex from 'UIKit/Box/Flex'
import { BoxProps } from 'UIKit/Box/types'
import Image from 'UIKit/Image'
import Page from 'UIKit/Page'
import Text from 'UIKit/Text'
import useComponentOnScreen from 'hooks/useComponentOnScreen'
import React from 'react'
import { Trans } from 'react-i18next'
import { useAppStatus } from 'state/app/hooks'
import styled from 'styled-components'
import { Icons } from 'svgs'
import hunnyTheme from 'theme'
import DisplaySocialMedia from 'views/BonusCenter/components/DisplaySocialMedia/DisplaySocialMedia'
import { RowBetween, RowCenter } from '../Row'
import CoinList from './CoinList'
import HunnyPartner from './HunnyPartner'
import OverviewInformation from './OverviewInformation'

const Footer: React.FC<BoxProps> = ({ ...props }) => {
  const { isLoaded: isDisplayHunnyPartner, ref } = useComponentOnScreen({
    root: null,
    rootMargin: '300px',
    threshold: 0,
  })

  const { isFinishFetch } = useAppStatus()

  return (
    <StyledFooter id="footer" ref={ref} {...props}>
      <StyledDisclaimerContainer>
        <StyleWrapLogoAndDescription>
          <RowBetween width="100%">
            <Image src="/logo-text.png" height={46} width={155} alt="logo" />
          </RowBetween>

          <Text
            mt={['12px', '20px']}
            fontWeight={400}
            fontSize="12px"
            lineHeight="16px"
            letterSpacing="-0.02em"
            color="textTertiary"
          >
            <Trans>
              This website offers gaming with risk experience. To be a user of our site you must be over 18 years old.
              We are not responsible for the violation of your local laws related to i-gaming. Play responsibly and have
              fun on HunnyPlay.
            </Trans>
          </Text>

          <Flex flexDirection="column">
            <Flex alignItems="center" m={['12px 0 22px', '16px 0 22px']}>
              <Box width="16px" mr="4px">
                <Icons.CopyRightIcon fill={hunnyTheme.colors.textSubtle} />
              </Box>
              <Text fontSize="10px" color="textSubtle">
                <Trans>2021-{{ year: new Date().getFullYear() }} HunnyPlay All Rights Reserved</Trans>
              </Text>
            </Flex>

            <DisplaySocialMedia />
          </Flex>
        </StyleWrapLogoAndDescription>

        <OverviewInformation />
      </StyledDisclaimerContainer>

      <CoinList />

      <Box mt={hunnyTheme.spacing.fix_600}>{isFinishFetch && isDisplayHunnyPartner && <HunnyPartner />}</Box>

      <RowCenter>
        <Text
          fontSize="12px"
          fontWeight={400}
          lineHeight="16px"
          textAlign="center"
          color="textSubtle"
          maxWidth="1200px"
          mt={hunnyTheme.spacing.fix_200}
        >
          <Trans>
            HunnyPlay is operated by Alchemy Games N.V., a company registered and established under the laws of Curacao
            Alchemy Games N.V.is licensed and regulated by Antillephone N.V. (license no. 8048/JAZ2024-001). Alchemy
            Games N.V., registration number is 164974 and its registered address is Hanchi Snoa 19 Trias Building
            Willemstad, Curaçao.
          </Trans>
        </Text>
      </RowCenter>
    </StyledFooter>
  )
}

const StyledFooter = styled(Page)`
  padding-top: 20px;

  width: 100%;
  flex-direction: column;
  justify-content: space-between;
  box-sizing: border-box;

  ${({ theme }) => theme.mediaQueries.md} {
    padding-top: 32px;
  }
`

const StyledContainer = styled(Flex)`
  width: 100%;
  box-sizing: border-box;
  justify-content: space-between;
`

const StyleWrapLogoAndDescription = styled(Flex)`
  flex-direction: column;
  align-items: flex-start;
  width: 100%;
  margin-bottom: 16px;

  ${({ theme }) => theme.mediaQueries.sm} {
    margin-bottom: 32px;
    width: 100%;
    padding-right: 0;
  }

  ${({ theme }) => theme.mediaQueries.xl} {
    width: 45%;
    padding-right: 5%;
    margin-bottom: 0;
  }
`

const StyledDisclaimerContainer = styled(StyledContainer)`
  height: auto;
  width: 100%;
  flex-wrap: wrap;
  flex-direction: column;

  ${({ theme }) => theme.mediaQueries.xl} {
    flex-direction: row;
    align-items: flex-start;
  }
`

export default Footer
